// src/components/viewer/DownloadZipPopup.jsx
import React from "react";
import { sendLinkToWhatsApp } from "../tools/DownloadZipTool";
import "../../styles/downloadZipPopup.css";

export default function DownloadZipPopup({ status, zipUrl, onClose }) {
  const recipientPhone = "7898096041"; // Replace dynamically with active patient data

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(zipUrl);
      alert("Sharing link copied to clipboard!");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="zipOverlay" onClick={onClose}>
      <div className="zipPopup" onClick={(e) => e.stopPropagation()}>
        
        {status === "processing" && (
          <div className="zipLoaderSection">
            <h2>Generating Cloud Share Link...</h2>
            <div className="spinner"></div>
            <p>Archiving DICOM slices securely on AWS S3. Please wait.</p>
          </div>
        )}

        {status === "error" && (
          <div className="zipErrorSection">
            <h2>Failed to Generate Link</h2>
            <p>Something went wrong on the backend server execution layer.</p>
            <button className="popupBtn" onClick={onClose}>Close</button>
          </div>
        )}

        {status === "success" && zipUrl && (
          <div className="zipSuccessSection">
            <h2>Link Ready to Share!</h2>
            <p>The secure access URL for this imaging series has been compiled successfully.</p>
            
            <input type="text" className="linkInput" value={zipUrl} readOnly style={{ width: '100%', padding: '8px', margin: '12px 0', background: '#333', color: '#fff', border: '1px solid #555', borderRadius: '4px' }} />

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '10px' }}>
              <button className="popupBtn" onClick={() => sendLinkToWhatsApp(recipientPhone, zipUrl)}>
                Share via WhatsApp Tab
              </button>
              <button className="popupBtn shadowBtn" onClick={handleCopy}>
                Copy Link to Clipboard
              </button>
              <button className="popupBtn closeBtn" onClick={onClose}>Close</button>
            </div>
          </div>
        )}
        
      </div>
    </div>
  );
}